import React, { useState } from "react";
/* eslint-disable import/no-unresolved */
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
// import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Pagination, Mousewheel } from "swiper";

import About from "../about";
import ProjectLists from "../projects";
import Intro from "./intro";
import Contact from "../contact";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Service from "../services";

function Home() {
  const isMobile = window.innerWidth < 768;
  const [isEnd, setIsEnd] = useState(false);
  const [slide, setSlide] = useState(0);
  const [swiper, setSwiper] = useState(null);
  const slideTo = (index) => swiper.slideTo(index);

  return (
    <div className="w-screen h-screen">
      <Navbar />
      <Swiper
        speed={1000}
        spaceBetween={30}
        onSwiper={setSwiper}
        hashNavigation={{
          watchState: true,
        }}
        onSlideChange={() => {
          setSlide(swiper.activeIndex);
          setIsEnd(swiper.isEnd);
        }}
        direction={isMobile ? "vertical" : "horizontal"}
        effect={"fade"}
        mousewheel={true}
        navigation={false}
        pagination={{
          clickable: true,
        }}
        modules={[EffectFade, Pagination, Mousewheel]}
        className="mySwiper"
      >
        <SwiperSlide>
          <Intro />
        </SwiperSlide>
        <SwiperSlide data-hash="slide2">
          <About />
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white w-full h-full flex justify-center items-center">
            <Service />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          {/* <Unique /> */}
          <ProjectLists />
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white w-full h-full flex justify-center items-center">
            <Contact />
          </div>
        </SwiperSlide>
      </Swiper>
      {!isMobile && <Footer slideTo={slideTo} slide={slide} isEnd={isEnd} />}
    </div>
  );
}

export default Home;
